import loadable from '@loadable/component';
export const manifest = {
  PickerButton: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "PickerButton";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "PickerButton" */
          './picker-button'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./picker-button");
            }

            return eval('require.resolve')("./picker-button");
          }

        }, {
          resolveComponent: m => m.PickerButton
        })
      }
    }
  },
  'PickerButton.LinkOption': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "PickerButtonLinkOption";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "PickerButtonLinkOption" */
          './picker-button-link-option'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./picker-button-link-option");
            }

            return eval('require.resolve')("./picker-button-link-option");
          }

        }, {
          resolveComponent: m => m.PickerButtonLinkOption
        })
      }
    }
  }
};